import React from 'react';
import Slice from './Slice';
export default class Chart extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        const radius = this.props.radius;
        const diameter = radius * 2;
        const sum = this.props.data.reduce((carry, current) => {
            return carry + current.value;
        }, 0);
        let startAngle = 0;
        return (React.createElement("div", { className: this.props.className },
            React.createElement("svg", { width: diameter, height: diameter, viewBox: '0 0 ' + diameter + ' ' + diameter, xmlns: "http://www.w3.org/2000/svg", version: "1.1" }, this.props.data.map((dataItem, sliceIndex) => {
                let nextAngle = startAngle;
                let angle = (dataItem.value / sum) * 360;
                let percent = (dataItem.value / sum) * 100;
                startAngle += angle;
                return (React.createElement(Slice, { key: sliceIndex, percentValue: percent, startAngle: nextAngle, angle: angle, radius: radius, fill: dataItem.color, stroke: this.props.stroke, strokeWidth: this.props.strokeWidth }));
            })),
            React.createElement("ul", null, this.props.data.map(dataItem => (React.createElement("li", { key: dataItem.label },
                React.createElement("span", { style: { color: dataItem.color } }, "\u25CF"),
                dataItem.label))))));
    }
}
